export default __webpack_public_path__ + "static/media/drawn-tree-highlighted-icon.c718d57d.svg";